import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { useSubheader } from "../../../_metronic/layout";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import * as columnFormatters from "../../components/column-formatters";
// import { Multiselect } from "multiselect-react-dropdown";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  ModalProgressBar,
  Input,
} from "../../../_metronic/_partials/controls";
import { Formik, Form, Field } from "formik";
import { Col, Row } from "react-bootstrap";
import GamerjiTournamentSummeryDetails from "./GamerjiTournamentSummeryDetails";

import {
  sortCaret,
  headerSortingClasses,
} from "../../../_metronic/_helpers";

// import * as Yup from "yup";
// import BootstrapTable from "react-bootstrap-table-next";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from "react-responsive-carousel";

import * as UIHelpers from "../../components/UIHelpers";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

const GamerjiTournamentRankSummary = (props) => {
  const { id } = useParams();
  let history = useHistory();

  const suhbeader = useSubheader();
  const dispatch = useDispatch();

  const [reloadcount, setReloadcount] = useState(0);
  const [columns, setColumns] = useState([]);

  const [frmInitialValues, setFrmInitialValues] = useState({
    roomId: "",
    roomPassword: "",
    steamLink: "",
    numberOfPlayedUsers: 0,
    isActive: true,
  });

  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );

  const {
    actionsLoading,
    // contestUsers,
    // listLoading,
    // tournamentForEdit,
    // tournamentRules,
    // bracketsImages,
    pointSummary,
    // tounamentUsers,
    // tounamentUsers1,
    // tournamentPointPool,
    // tournamentPrizePool,
  } = currentState;

  useEffect(() => {
    dispatch(actions.fetchSingleTournament(id, true));
    // dispatch(actions.fetchTournamentRules(id));
    dispatch(actions.fetchGamerjiRankSummary(id));
    // dispatch(actions.fetchTournamentPointPool(id));
    // dispatch(actions.fetchTournamentPrizePool(id));
  }, [id, dispatch]);


  useEffect(() => {
    suhbeader.setTitle("Tournament Rank Summary");
  }, [id]);

  useEffect(() => {
    var columns = [
      {
        dataField: "user",
        text: "User ID",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "uniqueIGN",
        text: "User Game Name",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },

      {
        dataField: "user.phone",
        text: "Mobile",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
    ];

    var tempColumn = [
      {
        dataField: "tAmounts",
        text: "Total Amount",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "tWiiningPrize",
        text: "Winning Prize",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "isHacker",
        text: "Is Hacker",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.HackerColumnFormatter,
      },
    ];
    var newColumns = [...columns, ...tempColumn];
    setColumns(newColumns);

    suhbeader.setTitle("Tournament Info ");
  }, [pointSummary, id]);

  const reloadLocation = () => {
    setReloadcount(reloadcount + 1);
    window.location.reload();
  };

  const saveWinning = (values) => {
    let users = [];
   
    pointSummary.tounamentUsers.forEach(async (user) => {
      if (pointSummary.item.isCustomRank) {
        var rank = values["rank_" + user._id] ? values["rank_" + user._id] : 0;
      } else {
        var rank = user.rank;
      }

      var tAmounts = 0;
      if (rank > 0 && !user.isHacking) {
        pointSummary.item.prizePooInfo.forEach((prizepoolItem) => {
          if (parseInt(prizepoolItem.rankTo) === 0) {
            if (parseInt(rank) == parseInt(prizepoolItem.rankFrom)) {
              tAmounts = parseInt(prizepoolItem.amount);
            }
          } else {
            if (
              parseInt(rank) >= parseInt(prizepoolItem.rankFrom) &&
              parseInt(rank) <= parseInt(prizepoolItem.rankTo)
            ) {
              tAmounts = parseInt(prizepoolItem.amount);
            }
          }
        });
      } else {
        tAmounts = 0;
      }

      users.push({
        amount: tAmounts,
        // contest: user.contest,
        // event: user.event,
        // createdAt: user.createdAt,
        // createdBy: user.createdBy,
        isHacking: user.isHacking,
        isHacker: user.isHacker,
        // game: user.game,
        // gameType: user.gameType,
        // isActive: user.isActive,
        // isDeleted: user.isDeleted,
        // kills: user.kills,
        // points: user.points,
        finalAmount: tAmounts,
        // team: user.team,
        // rankPoint: user.rankPoint,
        totalAmount: tAmounts,
        // uniqueIGN: user.uniqueIGN,
        // totalPoint: user.totalPoint,
        // totalRankPoints: user.totalRankPoints,
        // updatedAt: user.updatedAt,
        // updatedBy: user.updatedBy,
        // userId: user.user,
        rank: rank,
        user: user.user,
        companyCode: user.companyCode,
        isExtraPlayer: user.isExtraPlayer,
      });
    });

    let checkRank=[]
    let zerorankUser=[]
    let duplicate=[]
    if(pointSummary.item.winningTerm == "rank"){
      console.log(users);
      users.map((e)=>{
         if(e.rank<=0){
          zerorankUser.push(e)
         }else{
          if(checkRank.includes(e.rank)){
            duplicate.push(e)
          }else{
            checkRank.push(e.rank)
          }
         }
      })
     // const highest = Math.max(...checkRank);
     // console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^",zerorankUser,duplicate,checkRank,highest)
      if(duplicate?.length>0){
        NotificationManager.error("Please do not assign same rank", "Error");
        return;
      }
      if(zerorankUser?.length>0){
        NotificationManager.error("Rank should not be blank/zero", "Error");
        return;
      }
    }
    const params = {
      // event: pointSummary.item,
      // pointSummary: pointSummary,
      // tounamentUsers: tounamentUsers,
      // tounamentUsersData1: users,
      tounamentUsers: users,
    };
    // console.log("params-------------------------------------->",params)
   // console.log(users);
   // console.log("tournamentssssss8", pointSummary?.item)
   // console.log("tournamentssssss7", pointSummary)
 //  console.log("******************************************params",params)
    if (pointSummary && pointSummary.item && pointSummary.item._id) {
      const id = pointSummary.item._id;
     // console.log("tournamentssssss", pointSummary.item?.prizePoolType)
     // console.log("tournamentssssss5", pointSummary?.item)
    //  console.log("tounamentUsers----------->", users)
    if (pointSummary.item?.prizePoolType === 'rewards') {
   
      // Display or call the reward-specific API
      dispatch(actions.updateGamerjiEventWinningsreward(params, id)).then((success) =>
        success ? reloadLocation() : null
      );
    } else {
      // Call the default API
     // console.log("tournamentcccssssss8", pointSummary?.item)
      dispatch(actions.updateGamerjiEventWinnings(params, id)).then((success) =>
        success ? reloadLocation() : null
      );
    }
    }
  };

  return (
    <>
      <NotificationContainer />
      {actionsLoading && <ModalProgressBar />}
      <div className="col-md-12">
        <GamerjiTournamentSummeryDetails type={"view"} />
      </div>

      {pointSummary && pointSummary?.item && (
        <>
          <Formik
            enableReinitialize={true}
            initialValues={frmInitialValues}
            onSubmit={(values) => {
              saveWinning(values);
            }}
          >
            {({
              handleSubmit,
              errors,
              values,
              setFieldValue,
              validateField,
              validateForm,
            }) => (
              <Form className="form form-label-right w-100">
                <Row>
                  <Col className="mb-4 col-md-12">
                    <Card>
                      <CardHeader title="Tournament Users"></CardHeader>
                      <CardBody>
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr>
                              <th>Sr No</th>
                              <th>USER ID</th>
                              <th>IS PREMIUM</th>
                              <th>USER GAME NAME</th>
                              <th>RANK</th>
                              <th>TOTAL AMOUNT</th>
                              <th>WINNING PRIZE</th>
                              <th>WINNING AMOUNT WITH MULTIPLIER</th>
                              <th>IS HACKER</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pointSummary.item.status ===
                            UIHelpers.CONTEST_STATUS.review
                              ? pointSummary?.tounamentUsers.map(
                                  (data, indp) => {
                                    return (
                                      <tr
                                        key={"rankPointtab" + indp}
                                        style={{
                                          backgroundColor: data.isHacker
                                            ? "#f64e60"
                                            : "",
                                        }}
                                      >
                                        <td>{indp + 1}</td>
                                        <td>{data.user}</td>
                                        <td>
                                          {data.isPremium ? (
                                            <img
                                              alt="icon"
                                              src={toAbsoluteUrl(
                                                "/media/logos/43825.png"
                                              )}
                                              className="max-h-50px"
                                            />
                                          ) : (
                                            "N/A"
                                          )}
                                        </td>
                                        <td>{data.uniqueIGN}</td>

                                        <td>
                                          {pointSummary.item.isCustomRank ===
                                          true ? (
                                            <Field
                                              name={"rank_" + data._id}
                                              component={Input}
                                              placeholder="Rank"
                                              defaultValue={0}
                                              type="number"
                                              min={0}
                                              // value={data.rank}
                                            />
                                          ) : (
                                            data.rank
                                          )}
                                        </td>
                                        <td>
                                          {pointSummary.item.isCustomRank ===
                                          false
                                            ? data.tAmounts
                                            : 0}
                                        </td>
                                        <td>
                                          {pointSummary.item.isCustomRank ===
                                          false
                                            ? data.tAmounts
                                            : 0}
                                        </td>
                                        <td>{data.totalMultiplierAmount}</td>
                                        <td>{data.isHacker ? "Yes" : "No"}</td>
                                      </tr>
                                    );
                                  }
                                )
                              : pointSummary?.tounamentUsersData1.map(
                                  (data, indp) => {
                                    return (
                                      <tr
                                        key={"rankPointtab" + indp}
                                        style={{
                                          backgroundColor: data.isHacker
                                            ? "#f64e60"
                                            : "",
                                        }}
                                      >
                                        <td>{indp + 1}</td>
                                        <td>{data.user}</td>
                                        <td>
                                          {data.isPremium ? (
                                            <img
                                              alt="icon"
                                              src={toAbsoluteUrl(
                                                "/media/logos/43825.png"
                                              )}
                                              className="max-h-50px"
                                            />
                                          ) : (
                                            "N/A"
                                          )}
                                        </td>
                                        <td>{data.uniqueIGN}</td>
                                        <td>{data.rank}</td>
                                        <td>{data?.totalAmount || data?.reward || 0}</td>
                                        <td>{data?.reward ? pointSummary?.item?.rewardDisplayText : "-"}</td>
                                        {/* {console.log("testingsss", pointSummary?.item)} */}
                                        <td>{data.totalMultiplierAmount}</td>
                                        <td>{data.isHacker ? "Yes" : "No"}</td>
                                      </tr>
                                    );
                                  }
                                )}
                          </tbody>
                        </table>
                      </CardBody>
                      {pointSummary?.item?.status ===
                        UIHelpers.CONTEST_STATUS.review && (
                        <CardFooter className="text-right">
                          <button
                            type="button"
                            disabled={actionsLoading}
                            className="btn btn-primary"
                            onClick={() => saveWinning(values)}
                          >
                            {actionsLoading && (
                              <i
                                class="fa fa-spin fa-spinner"
                                aria-hidden="true"
                              ></i>
                            )}
                            Submit
                          </button>
                        </CardFooter>
                      )}
                    </Card>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </>
      )}
    </>
  );
};

export default GamerjiTournamentRankSummary;
